// extracted by mini-css-extract-plugin
export const atlasGrotesk = "font-faces__atlasGrotesk__rYPJr";
export const atlasGroteskBold = "font-faces__atlasGroteskBold__jZ5W5 font-faces__atlasGrotesk__rYPJr";
export const atlasGroteskMedium = "font-faces__atlasGroteskMedium__1ilbx font-faces__atlasGrotesk__rYPJr";
export const atlasGroteskRegular = "font-faces__atlasGroteskRegular__J2QD8 font-faces__atlasGrotesk__rYPJr";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const sans = "font-faces__sans__uCf65";
export const sansBold = "font-faces__sansBold__vF+EN font-faces__sans__uCf65";
export const sansLight = "font-faces__sansLight__-1Yzy font-faces__sans__uCf65";
export const sansMedium = "font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const sansRegular = "font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const sansSemibold = "font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const semibold = "600";
export const serif = "font-faces__serif__XseuP";
export const serifLight = "font-faces__serifLight__iGPdI font-faces__serif__XseuP";
export const serifMedium = "font-faces__serifMedium__n-4rV font-faces__serif__XseuP";
export const serifRegular = "font-faces__serifRegular__wxRr3 font-faces__serif__XseuP";